import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../../store/actions/notificationAction';
import { deleteServiceFromCart } from '../../../../store/actions/cartAction';
import { receiveServicesAndTariff } from '../../../../store/actions/addServiceAndTariffAction';

import awbRemote from '../../../../api/awbRemote';
import addServicesRemote from '../../../../api/addServicesRemote';
import AdditionalServicesModal from './AdditionalServicesModal';

import Awb from '../../../../models/Awb';
import Cart from '../../../../models/Cart';
import ApiResponse from '../../../../models/ApiResponse';
import AddServicesTariff from '../../../../models/AddServicesTariff';
import ResponseError from '../../../../models/ResponseError';
import FeeParams from '../../../../models/FeeParams';
import FeeTotal from '../../../../models/FeeTotal';

import { getAdditionalServicesNames, AddServiceRawType } from '../../../../utils/additionalServices';
import { findCartItemByCodeAndNumber, CART_ITEM_SCHEMA } from '../../../../utils/cartService';
import { AWB_SCHEMA } from '../../../../utils/airwayBill';
import GhaModel from '../../../../models/Gha';

interface AdditionalServicesModalContainerProps {
  modalOpen: boolean;
  handleClose: () => void;
  selectedAwbCode: string;
  selectedAwbNumber: string;
  selectedAwbVer: number;
  receiveError: Function;
  additionalService: AddServicesTariff;
  cart: Cart;
  deleteServiceFromCart: Function;
  gha: GhaModel;
  getServicesAndTariff: Function;
  isExport?: boolean;
};

interface AdditionalServicesModalContainerState {
  additionalServicesTariff: AddServicesTariff;
  additionalServiceNames: Array<[string, AddServiceRawType]>;
  selectedAwbCode: string;
  selectedAwbNumber: string;
  selectedAwbVer: number;
  selectedServiceRawName: string;
  selectedServiceDescription: string;
  selectedServiceDetails: any;
  total: number;
  awb: Awb;
  isDeletedService: boolean;
};

class AdditionalServicesModalContainer extends Component<AdditionalServicesModalContainerProps, AdditionalServicesModalContainerState> {

  state = {
    additionalServicesTariff: {
      breakdown_hawb: { cost_per_kg_usd: 0 },
      bup_ld3: { cost_usd: 0 },
      bup_ld7: { cost_usd: 0 },
      bup_20ft: { cost_usd: 0 },
      bup_q7: { cost_usd: 0 },
      label_freight: { cost_per_box_usd: 0 },
      bup_main_deck: { cost_usd: 0 },
      import_service: { cost_usd: 0 },
      return_fee: { cost_usd: 0 },
      per_hawb: { cost_per_hawb_usd: 0 },
      per_hawb_exclude_import_service: { cost_per_hawb_usd: 0 },
      reicing: { cost_per_kg_usd: 0 },
      perishable_storage: {cost_per_day_min_usd: 0, cost_per_kg_per_day_usd: 0},
      cage_vault: {cost_per_day_min_usd: 0, cost_per_kg_per_day_usd: 0},
      storage_fee: { 
        free_days: 0, min_cost_usd: 0, storage_divisor: 0, first_weekend_free: false, arrival_day_counted: false, 
        all_public_holidays_counted: false, first_public_holiday_counted: false, cost_per_storage_unit_per_day_usd: 0
      },
      customs_fee: {
        us_customs_fee: 0, ces_handling_fee: 0, in_bond_fee: 0, processing_fee: 0, 
        transportation_fee: 0, min_cost_usd: 0
      },
      other: {},
      gha_adjust: {},
      skid_exch: { cost_usd: 0 },
      comat: {},
      copa_comat: {},
      nomination_fee: { cost_usd: 0 },
      certified_manifest_charge: { cost_usd: 0 },
    },
    additionalServiceNames: [],
    awb: AWB_SCHEMA,
    selectedAwbCode: '',
    selectedAwbNumber: '',
    selectedAwbVer: 0,
    selectedServiceRawName: '',
    selectedServiceDescription: '',
    selectedServiceDetails: {},
    total: 0,
    isDeletedService: false
  }

    static getDerivedStateFromProps(nextProps: AdditionalServicesModalContainerProps, prevState: AdditionalServicesModalContainerState) {

      if (nextProps.selectedAwbCode !== prevState.selectedAwbCode && nextProps.selectedAwbNumber !== prevState.selectedAwbNumber) {
        return { selectedAwbCode: nextProps.selectedAwbCode, selectedAwbNumber: nextProps.selectedAwbNumber };
      }

      else return null;
    }

    componentDidUpdate(prevProps: AdditionalServicesModalContainerProps) {

      if (prevProps.additionalService !== this.props.additionalService) {
        this.setAdditionalServicesTariff();
      }
    }

    componentDidMount() {

      this.props.getServicesAndTariff(this.state.selectedAwbCode, this.state.selectedAwbNumber, this.props.selectedAwbVer, this.props.isExport);
      awbRemote.getAwbByCodeAndNumber(this.state.selectedAwbCode, this.state.selectedAwbNumber, this.props.isExport || false, this.props.selectedAwbVer).then((res: ApiResponse<Awb>) => {

        const awb: Awb | undefined = res.result;
        const error: ResponseError | undefined = res.error;

        if (awb) {
          this.setState({ awb });
        } 
    
        if (error) {
          this.props.receiveError(error);
        }
      });
      this.setAdditionalServicesTariff();
    }

    setAdditionalServicesTariff = (): void => {
      const additionalServicesTariff: AddServicesTariff = this.props.additionalService;
        const addServiceTariffs: Array<AddServiceRawType> = Object.keys(additionalServicesTariff) as Array<AddServiceRawType>;
        let additionalServiceNames: Array<[string, AddServiceRawType]> = getAdditionalServicesNames(addServiceTariffs);
        additionalServiceNames = additionalServiceNames.filter((service) => addServiceTariffs.find(s => s ===  service[1]) !=null);
  
        this.setState({ additionalServicesTariff, additionalServiceNames });
    }

    handleChange = (event: any): void => {

      const serviceRawName: AddServiceRawType = event.target.value;
      let serviceDescription: string = this.props.gha.info.serviceDescriptions[serviceRawName];
      if (!serviceDescription && serviceRawName === 'certified_manifest_charge') {
        serviceDescription = 'Certified Manifest Charge';
      }
      const serviceDetails = this.state.additionalServicesTariff[serviceRawName];

      this.setState({
        selectedServiceRawName: serviceRawName,
        selectedServiceDescription: serviceDescription,
        selectedServiceDetails: serviceDetails,
        total: 0
      });
    };

    getFeeRequest = (params: FeeParams): void => {

      addServicesRemote.getFee(this.state.selectedServiceRawName, this.props.selectedAwbCode, this.props.selectedAwbNumber, this.props.selectedAwbVer, params, this.props.isExport).then((res: ApiResponse<FeeTotal>) => {

        const feeTotal: FeeTotal | undefined = res.result;
        const error: ResponseError | undefined = res.error;
  
        if (feeTotal) {
          this.setState({ total: feeTotal.total });
        } 
  
        if (error) {
          this.props.receiveError(error);
        }
      });
    };

    handleDeleteService = (serviceType: string, reason?: string): void => {

      this.changeIsDeleteStatus(true);
      this.props.deleteServiceFromCart(this.state.selectedAwbCode, this.state.selectedAwbNumber, serviceType, reason, this.props.isExport);
    }

    changeIsDeleteStatus = (flag: boolean): void => {
      this.setState({ isDeletedService: flag });
    }

    render() {
      if (this.state.additionalServiceNames.length > 0) {
        return (
          <AdditionalServicesModal
            modalOpen={ this.props.modalOpen }
            handleClose={ this.props.handleClose }
            handleChange={ this.handleChange }
            awb={ this.state.awb }
            additionalServiceNames={ this.state.additionalServiceNames }
            serviceRawName={ this.state.selectedServiceRawName }
            serviceDescription={ this.state.selectedServiceDescription }
            serviceDetails={ this.state.selectedServiceDetails }
            total={ this.state.total }
            getFeeRequest={ this.getFeeRequest }
            cartItem={ findCartItemByCodeAndNumber(this.state.selectedAwbCode, this.state.selectedAwbNumber, this.props.cart) || { ...CART_ITEM_SCHEMA, code: this.state.selectedAwbCode, number: this.state.selectedAwbNumber, version: this.state.awb.version || this.props.selectedAwbVer, allowedServices: { ...CART_ITEM_SCHEMA.allowedServices, certified_manifest_charge: true } } }
            deleteService={ this.handleDeleteService }
            isDeletedService={ this.state.isDeletedService }
            changeIsDeleteStatus={ this.changeIsDeleteStatus }
            isExport={ this.props.isExport }
          />
        );
      } else {
        return null;
      }
    }
}

const mapStateToProps = (state: any) => {
  return {
    additionalService: state.additionalService,
    cart: state.cart,
    gha: state.ghaInfo
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    getServicesAndTariff: (awbCode: string, awbNumber: string, ver: number, isExport: boolean) => dispatch(receiveServicesAndTariff(awbCode, awbNumber, ver, isExport)),
    deleteServiceFromCart: (awbCode: string, awbNumber: string, service: string, reason?: string, isExport?: boolean) => dispatch(deleteServiceFromCart(awbCode, awbNumber, service, reason, isExport))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalServicesModalContainer);